<div class="view-header" [class.no-banner]="embedService.embed">
  @if (job$ | async; as job) {
    <div class="view-header-content">
      <h1>{{ job.jobTitle }}</h1>
      <div class="content">
        @if (!refService.refCompany && !embedService.embed) {
          <ul>
            <li>{{ job.companyTitle }}</li>
            @if (job?.website) {
              <li>
                <a [href]="job?.website" target="_blank">
                  {{ 'jobboard.static.header.website' | transloco }}
                  <fa-icon [icon]="fontawesomeService.regular.externalLink"></fa-icon>
                </a>
              </li>
            }
          </ul>
        }
        <div class="description">
          <app-header-tags
            [startDate]="job.startDate"
            [employmentType]="job.employmentType"
            [workingTime]="job.workingTime"
            [locations]="job.workLocations"
            [workingModel]="job.workingModel"
            [searchRegionAddress]="job.searchRegionAddress"
            [showSalaryRangeOnJobboard]="job.showSalaryRangeOnJobboard ?? false"
            [salaryCurrency]="job.currency"
            [salaryMin]="job.salaryMin"
            [salaryMax]="job.salaryMax"
            [fallbackSalary]="job.salary"
            [salaryInterval]="job.salaryInterval"
          ></app-header-tags>
          @if (!submitSuccess() && job && job?.open && linkValid() === true) {
            <div class="apply d-flex align-items-center">
              <a (click)="goToManualApply()" class="ct-btn ct-btn-themed apply-btn">
                <fa-icon [icon]="fontawesomeService.regular.pen" class="me-2"></fa-icon>
                {{ 'jobboard.views.job.apply-now-manually' | transloco }}
              </a>
              <a (click)="prefillModal.open()" class="ct-btn ct-btn-themed-solid apply-btn ms-2">
                <fa-icon [icon]="fontawesomeService.regular.user" class="me-2"></fa-icon>
                {{ 'jobboard.views.job.apply-now-with-profile' | transloco }}
              </a>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
@if (linkValid() === true) {
  @if (!submitSuccess()) {
    @if (job$ | async; as job) {
      <div class="view-content">
        <h1>{{ job.jobTitle }}</h1>
        <div class="view-section">
          @if (!job?.open) {
            <ct-lib-inline-info>
              <p>{{ 'jobboard.views.job.closed-info' | transloco }}</p>
            </ct-lib-inline-info>
          }
          @for (description of job.description; track description) {
            <ct-lib-markdown-viewer [value]="description"></ct-lib-markdown-viewer>
          }
          @if (job?.open) {
            <div class="apply">
              <a (click)="goToManualApply()" class="ct-btn ct-btn-themed apply-btn">
                <fa-icon [icon]="fontawesomeService.regular.pen" class="me-2"></fa-icon>
                {{ 'jobboard.views.job.apply-now-manually' | transloco }}
              </a>
              <a (click)="prefillModal.open()" class="ct-btn ct-btn-themed-solid apply-btn ms-2">
                <fa-icon [icon]="fontawesomeService.regular.user" class="me-2"></fa-icon>
                {{ 'jobboard.views.job.apply-now-with-profile' | transloco }}
              </a>
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <div class="view-content success">
      <div class="d-flex flex-column align-items-center">
        <app-animated-check [color]="colorService.accent"></app-animated-check>
        <p class="mt-5">{{ 'jobboard.views.apply.sections.finish.done' | transloco }}</p>
      </div>
    </div>
  }
} @else if (linkValid() === false) {
  <div class="view-content">
    <div class="d-flex flex-column align-items-center">
      <app-animated-cross></app-animated-cross>
      <p class="mt-5">{{ 'jobboard.views.job.recommendation-link-invalid' | transloco }}</p>
    </div>
  </div>
}
<ct-lib-modal
  [label]="'jobboard.views.apply.prefill-modal.title' | transloco"
  [footer]="prefillModalFooter"
  #prefillModal
  >
  <div class="prefill-modal" [innerHTML]="'jobboard.views.apply.prefill-modal.content' | transloco"></div>
</ct-lib-modal>
<ng-template #prefillModalFooter>
  <button class="ct-btn ct-btn-red" (click)="prefillModal.close()">
    {{ 'jobboard.views.apply.prefill-modal.cancel-button' | transloco }}
  </button>
  <a class="ct-btn ct-btn-themed ms-auto" (click)="goToManualApply()">
    {{ 'jobboard.views.apply.prefill-modal.manual-button' | transloco }}
  </a>
  <button class="ct-btn ct-btn-themed-solid ms-2" (click)="applyWithPrefillData()" [disabled]="loading()">
    @if (loading()) {
      <ct-lib-spinner></ct-lib-spinner>
    }
    {{ 'jobboard.views.apply.prefill-modal.submit-button' | transloco }}
  </button>
</ng-template>
